// extracted by mini-css-extract-plugin
export default {"root":"styles_root__0Vm40","tableBlockTitle":"styles_tableBlockTitle__bgnkU","tableBlockData":"styles_tableBlockData__IWQb3","inUse":"styles_inUse__ubxOq"};